var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 1.66669L18.3337 5.00002M1.66699 18.3334L2.73066 14.4332C2.80006 14.1788 2.83475 14.0516 2.88802 13.9329C2.93531 13.8276 2.99343 13.7274 3.06142 13.6341C3.138 13.529 3.23125 13.4358 3.41775 13.2493L12.0289 4.63809C12.1939 4.47308 12.2764 4.39058 12.3716 4.35967C12.4553 4.33248 12.5454 4.33248 12.6291 4.35967C12.7242 4.39058 12.8067 4.47308 12.9717 4.63809L15.3623 7.02862C15.5273 7.19362 15.6098 7.27613 15.6407 7.37126C15.6679 7.45495 15.6679 7.54509 15.6407 7.62878C15.6098 7.72391 15.5273 7.80642 15.3623 7.97143L6.75108 16.5826C6.56458 16.7691 6.47134 16.8623 6.36623 16.9389C6.2729 17.0069 6.17276 17.065 6.06742 17.1123C5.94878 17.1656 5.82156 17.2003 5.56711 17.2697L1.66699 18.3334Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil02);
export default __webpack_public_path__ + "static/media/pencil-02.9d6228142005f384a06cab5458665a83.svg";
export { ForwardRef as ReactComponent };